import { useAuth0 } from '@auth0/auth0-react';

const NavBar = () => {

    const { isAuthenticated, loginWithRedirect, logout } = useAuth0();

    const login = () => loginWithRedirect();
    const handleLogout = () => logout({ logoutParams: { returnTo: window.location.origin } });

    return (
        <div id="navbar">
            <div className="wordmark">FractalArt</div>
            <div className="nav-actions">
                <button type="button" className="nav-link">Gallery</button>
                {!isAuthenticated
                    ? <button type="button" className="nav-link" onClick={login}>Login</button>
                    : <button type="button" className="nav-link" onClick={handleLogout}>Logout</button>}
            </div>
        </div>
    );
};

export default NavBar;
